define(function(require, exports, module) {
    'use strict';
    var BaseModel = require('common/base.model');
    var core = require('core');
    var user = require('user');
    var authManager = require('auth');
    var pas = require('util/pas.util');
    var url = require('util/url.util');
    const { dispatcher } = require('bundle');

    module.exports = BaseModel.extend({
        initialize: function() {
            var deliveryPlatformFromUrl = url.getLocationParameterByName('deliveryPlatform');
            var deliveryPlatform = deliveryPlatformFromUrl && deliveryPlatformFromUrl.toLowerCase() === 'native';

            if (authManager.isAdmin() || !deliveryPlatform) {
                return;
            }

            // window.monitorEvents(window, 'message');

            if (dispatcher) {
                dispatcher.listen('auth:credentials:login', this.handleLoginSuccess);
            }

            this.listenTo(core, {
                'registration:success': this.handleRegistrationSuccess,
                'deposit:success': this.handleDepositSuccess,
                'deposit:fail': this.handleDepositFailed,
            });
        },

        handleRegistrationSuccess: function() {
            window.postMessage(JSON.stringify({
                url: 'register',
                data: {
                    status: 'success',
                    username: user.get('userName')
                }
            }));
        },

        handleLoginSuccess: function() {
            pas.getTempToken().then((response) => {
                window.postMessage(JSON.stringify({
                    url: user.get('previousLoginTime') ? 'login' : 'firstlogin',
                    data: {
                        status: 'success',
                        userId: user.get('userDetails').userId,
                        username: user.get('userName'),
                        tempToken: response.data.sessionToken.sessionToken
                    }
                }));
            });
        },

        handleDepositSuccess: function(data) {
            var transaction = data.payments && data.payments.transaction;
            var depositAmount = data.amount || transaction && transaction.length && transaction[0].amount;
            var totalDepositCount = user.get('paymentsStatistics').deposits.totalDepositCount;

            depositAmount = parseInt(depositAmount);
            totalDepositCount = parseInt(totalDepositCount) || 0;

            if (data.methodCode) { // for non-redirect PM request for paymentsStatistics sends after `deposit:success` event
                totalDepositCount += 1;
            }

            if (totalDepositCount === 1) {
                window.postMessage(JSON.stringify({
                    url: 'deposits',
                    data: {
                        status: 'success',
                        depositType: 'FTD',
                        userId: user.get('userDetails').userId,
                        amount: parseInt(depositAmount),
                        currency: user.get('currencyCode')
                    }
                }));
            } else if (totalDepositCount >= 2) {
                window.postMessage(JSON.stringify({
                    url: 'deposits',
                    data: {
                        status: 'success',
                        depositType: 'SDeposit',
                        userId: user.get('userDetails').userId,
                        amount: parseInt(depositAmount),
                        currency: user.get('currencyCode')
                    }
                }));
            }
        },

        handleDepositFailed: function(data) {
            var totalDepositCount = user.get('paymentsStatistics').deposits.totalDepositCount;

            totalDepositCount = parseInt(totalDepositCount) || 0;

            window.postMessage(JSON.stringify({
                url: 'deposits',
                data: {
                    status: 'fail',
                    depositType: totalDepositCount > 1 ? 'SDeposit' : 'FTD',
                    userId: user.get('userDetails').userId,
                    amount: parseInt(data.amount),
                    currency: user.get('currencyCode')
                }
            }));
        }
    });
});